if(themeVariables?.customer){
  // Api end point for customer update
  const GET_CUSTOMER_API = 'https://alboom-express.codilar.in/yalla/customer';

  // Api end point for customer points data
  const GET_LOYALTY_API = 'https://alboom-express.codilar.in/yalla/loyalty';

  // API key for testing purpose until wrapper comes
  const API_KEY = "m5jicKiuoS2SQSzVCWZTqfGDwOBlb5";

  // Add customer phone in account
  const ADD_PHONE_TO_SHOPIFY_ACCOUNT_API = "https://alboom-express.codilar.in/sf/customer/update";

  // Registered section
  const registeredYallaSection = document.querySelector('.registered-yalla');

  // Unregistered section
  const unregisteredYallaSection = document.querySelector('.unregistered-yalla');

  // Customer phone
  let customerPhone = themeVariables?.customer?.phone;

  // Customer id
  const customerId = themeVariables?.customer?.customerId;

  // Customer Prefence checkbox form
  const preferenceForm = document.querySelector('.preference-form');

  // Initial state of the preference checkboxes
  let initialConsentState = {};

  // preference update message
  const { preferenceSuccess, preferenceError } = themeVariables?.customer?.preferenceMessage;

  // store handle/id
  const storeHandle = themeVariables?.store?.storeHandle;

  // Transaction history htmls
  const transactionBlock = document.querySelector('.transaction-history');
  const tableBody = document.getElementById('transaction-table-body');
  const sortSelect = document.getElementById('transaction-sort');
  const paginationContainer = document.getElementById('transaction-pagination');

  // State
  let currentPage = 1;
  let totalPages = 1;
  let sortBy = 'recent';

  // Page size for customer points history
  const pageSize = themeVariables?.customer?.transactionHistory?.pointsHistoryPageSize;

  // Previous text
  const previousText = themeVariables?.customer?.transactionHistory?.previous;

  // Next text
  const nextText = themeVariables?.customer?.transactionHistory?.next;

  // Html template for no transaction history
  const noHistoryTemplate = themeVariables?.customer?.transactionHistory?.noHistoryTemplate;

  const popupTrigger = document.querySelector('.js-yalla-popup-trigger');
  const popup = document.getElementById('yalla-popup');
  const closeButtons = document.querySelectorAll('.js-yalla-popup-close');
  const consentCheckbox = document.getElementById('yalla-consent-checkbox');
  const submitButton = popup?.querySelector('.yalla-popup__submit-button');

  const countryPhoneCodeSelector = popup.querySelector('#country-code');
  const countryListBox = popup.querySelector('#country-list');

  document.addEventListener('DOMContentLoaded', () => {

    initiateRendering();

  });

  const initiateRendering = async (phone) => {
    if(typeof phone !== 'undefined') {
      customerPhone = phone;
    }
    const response = await getCustomerData(customerPhone);

    if(response && response.status && response.code === 200) {
      registeredYallaSection?.classList.remove('hidden');
      unregisteredYallaSection?.remove();
      if(customerPhone) {
        initRewards(customerPhone);
        if(preferenceForm) {
          setInitialConsent(customerPhone);
          preferenceForm.addEventListener('submit', (e) => {
            e.preventDefault();
            sendPreferenceUpdate();
          });
        }
        if(transactionBlock) {
          // Initial load
          fetchAndRender();

          // Sort change event
          sortSelect.addEventListener('change', () => {
            sortBy = sortSelect.value;
            fetchAndRender();
          });
        }

      }
    } else {
      if(unregisteredYallaSection) {
        unregisteredYallaSection.classList.remove('hidden');
      }
      popupTrigger?.addEventListener('click', openPopup);
      countryPhoneCodeSelector?.addEventListener('click', openCountryList) // open country phone code list
      countryListBox?.querySelectorAll('.country-item').forEach(item => {
        item.addEventListener('click', selectCountry);
      });
      closeButtons?.forEach(btn => btn.addEventListener('click', closePopup));
      consentCheckbox?.addEventListener('change', handleConsentChange);
      submitButton?.addEventListener('click', handleSubmit);
    }
  }

  // fetch points data
  const fetchPointsData = async (customerPhone, pageNo = 0, pageSize = 10) => {

    const url = `${GET_LOYALTY_API}?action=points_history&customerPhone=${customerPhone}&pageNo=${pageNo}&pageSize=${pageSize}&shopName=reebok_ae`;


    try {
      const response = await fetch(url);

      if (!response.ok) {
        console.error('Network response was not ok:', response.status, response.statusText);
        return { status: false, error: `HTTP ${response.status}` };
      }

      const data = await response.json();

      if (typeof data !== 'object' || data === null) {
        console.error('Unexpected response format:', data);
        return { status: false, error: 'Invalid data format' };
      }
      console.log(data);
      return data;
    }
    catch (error) {
      console.error('Error fetching points history:', error);
      return { status: false, error: error.message };
    }
  }

  // Update Yalla explorer boxes
  const updateRewardBoxes = (pointsData) => {
    const points = pointsData.data.customerPointsHistory;
    let balanceTemplate = themeVariables?.customer?.balanceTemplate;
    const mapping = {
      balance: points?.currentPoints,
      earned: points?.earnedPoints,
      redeemed: points?.burnedPoints,
      expired: points?.totalExpiredPoints
    };

    Object.entries(mapping).forEach(([key, value]) => {
      const el = document.querySelector(`.yalla-rewards__value[data-type="${key}"]`);
      if (el && balanceTemplate) {
        const pointsHtml = balanceTemplate.replace("[balance]", `<span class="points-value">${value}</span>`);
        el.innerHTML = decodeURIComponent(pointsHtml);
      }
    });
  }


  // Initialize the yalla explorer boxes
  const initRewards = async (customerPhone) => {
    const pointsData = await fetchPointsData(customerPhone);
    updateRewardBoxes(pointsData);
  }

  /* ============ Preference ============ */

  // Get customer data
  const getCustomerData = async (customerPhone) => {
    if(!GET_CUSTOMER_API) return;
    const options = {
      method: 'GET',
      headers: {accept: 'application/json'}
    };

    try {
      const response = await fetch(`${GET_CUSTOMER_API}?action=get&customer_phone=${customerPhone}&shopName=reebok_ae`, options);

      if (!response.ok) {
        console.error('Network response was not ok:', response.status, response.statusText);
        return { code: response.status, error: `HTTP ${response.status}` };
      }

      const data = await response.json();

      if (typeof data !== 'object' || data === null) {
        console.error('Unexpected response format:', data);
        return { code: 422, error: 'Invalid data format' };
      }
      return data;
    }
    catch (error) {
      console.error('Error fetching customer:', error);
      return { code: 400, error: error.message };
    }
  }

  // Set initial consent
  const setInitialConsent = async (customerPhone) => {
    const response = await getCustomerData(customerPhone);
    console.log(response);
    if (!response || !response.status || !response.data?.consent) {
      console.warn('Consent data not found.');
      return;
    }

    const consent = response.data.consent;


    const checkboxes = preferenceForm.querySelectorAll('.preference-checkbox');
    checkboxes.forEach(checkbox => {
      const type = checkbox.dataset.type;
      const isOptedIn = consent?.[type] === 'opt_in';

      checkbox.checked = isOptedIn;
      // Save initial state
      initialConsentState[type] = isOptedIn;
    });
  };

  // get consent payload
  const getConsentPayload = () => {
    const consent = {};
    const checkboxes = preferenceForm.querySelectorAll('.preference-checkbox');

    checkboxes.forEach((checkbox) => {
        const type = checkbox.dataset.type;
        if (checkbox.checked) {
          consent[type] = 'opt_in';
        } else {
          consent[type] = 'opt_out';
        }
    });

    return {
      customer_data: {
        customer_details: [
          {
            number: customerPhone,
            consent
          }
        ]
      }
    };
  };

  // restore to initial consent state
  const restoreInitialConsentState = () => {
    const checkboxes = preferenceForm.querySelectorAll('.preference-checkbox');

    checkboxes.forEach(checkbox => {
      const type = checkbox.dataset.type;
      checkbox.checked = initialConsentState[type] || false;
    });
  };

  let preferenceMessageTimeout;

  const showPreferenceMessage = (message, type = 'success', messageContainer, duration = 4000) => {
    if (!messageContainer) return;

    clearTimeout(preferenceMessageTimeout); // Clear any existing timer

    const responseMessage = message !== '' ? message : (type === 'success' ? "Preferences updated successfully!" : "Something went wrong.")

    messageContainer.textContent = message;
    messageContainer.classList.add(type);
    messageContainer.style.display = 'block';

    preferenceMessageTimeout = setTimeout(() => {
      messageContainer.style.display = 'none';
      messageContainer.textContent = '';
      messageContainer.classList.remove(type);
    }, duration);
  };

  // send Preference update
  const sendPreferenceUpdate = async () => {
    const messageContainer = document.querySelector('.preference-form__message');
    const payload = getConsentPayload();
    const options = {
      method: 'POST',
      headers: {
        accept: 'application/json',
        'content-type': 'application/json'
      },
      body: JSON.stringify(payload)
    };

    try {
      const response = await fetch(`${GET_CUSTOMER_API}?action=add&shopName=reebok_ae`, options);

      if (!response.ok) {
        throw new Error(`API error: ${response.status}`);
        showPreferenceMessage(preferenceError, 'error', messageContainer);
        restoreInitialConsentState();
      }

      const data = await response.json();
      if(data.status) {
        console.log('Preferences updated:', data);
        showPreferenceMessage(preferenceSuccess, 'success', messageContainer);
      } else {
        console.log('Error: ', data);
        showPreferenceMessage(preferenceError, 'error', messageContainer);
        restoreInitialConsentState();
      }
    } catch (error) {
      console.error('Error updating preferences:', error);
      restoreInitialConsentState();
      showPreferenceMessage(preferenceError, 'error', messageContainer);
    }
  };

  /* ============ Transaction history ================== */

  // Sort transactions client-side
  const sortTransactions = (transactions, sortKey) => {
    const sorted = [...transactions];
    switch (sortKey) {
      case 'earned':
        sorted.sort((a, b) => b.points - a.points);
        break;
      case 'redeemed':
        sorted.sort((a, b) => b.pointsRedeemed - a.pointsRedeemed);
        break;
      case 'old':
        sorted.sort((a, b) => new Date(a.actionDate) - new Date(b.actionDate));
        break;
      case 'date':
      case 'recent':
      default:
        sorted.sort((a, b) => new Date(b.actionDate) - new Date(a.actionDate));
        break;
    }
    return sorted;
  };

  // Render table rows
  const renderTable = (transactions) => {
    if (!transactions.length) {
      tableBody.innerHTML = `<tr><td colspan="5" style="text-align:center;">${noHistoryTemplate}</td></tr>`;
      return;
    }
    const pointsString = themeVariables?.customer?.transactionHistory?.tableData?.points;
    const rows = transactions.map(tx => {
      const orderId = tx.billNo || '-';
      const placedOn = new Date(tx.actionDate).toLocaleDateString();
      const pointsEarned = tx.points > 0 && tx.actionType === 'earn' ? `${tx.points} ${pointsString}` : `0 ${pointsString}`;
      const pointsRedeemed = `${tx.pointsRedeemed} ${pointsString}` || `0 ${pointsString}`;
      const balance = `${tx.pointsLeft} ${pointsString}` || `0 ${pointsString}`;

      return `<tr>
        <td data-th="${themeVariables?.customer?.transactionHistory?.tableHeadings?.orderId || ''}">${orderId}</td>
        <td data-th="${themeVariables?.customer?.transactionHistory?.tableHeadings?.placedOn || ''}">${placedOn}</td>
        <td data-th="${themeVariables?.customer?.transactionHistory?.tableHeadings?.pointsEarned || ''}">${pointsEarned}</td>
        <td data-th="${themeVariables?.customer?.transactionHistory?.tableHeadings?.pointsRedeemed || ''}">${pointsRedeemed}</td>
        <td data-th="${themeVariables?.customer?.transactionHistory?.tableHeadings?.balancePoints || ''}">${balance}</td>
      </tr>`;
    }).join('');

    tableBody.innerHTML = rows;
  };

  // Render pagination buttons
  const renderPagination = () => {
    if (totalPages <= 1) {
      paginationContainer.innerHTML = '';
      return;
    }

    let buttonsHTML = '';

    // Previous button
    buttonsHTML += `<button class="pagination-btn" data-page="${currentPage - 1}" ${currentPage === 1 ? 'disabled' : ''}>${previousText}</button>`;

    // Page number buttons (show all)
    for (let i = 1; i <= totalPages; i++) {
      buttonsHTML += `<button class="pagination-btn${i === currentPage ? ' active' : ''}" data-page="${i}">${i}</button>`;
    }

    // Next button
    buttonsHTML += `<button class="pagination-btn" data-page="${currentPage + 1}" ${currentPage === totalPages ? 'disabled' : ''}>${nextText}</button>`;

    paginationContainer.innerHTML = buttonsHTML;

    // Add event listeners to buttons
    const btns = paginationContainer.querySelectorAll('.pagination-btn');
    btns.forEach(btn => {
      btn.addEventListener('click', () => {
        const selectedPage = parseInt(btn.getAttribute('data-page'));
        if (selectedPage && selectedPage !== currentPage && selectedPage >= 1 && selectedPage <= totalPages) {
          currentPage = selectedPage;
          fetchAndRender();
        }
      });
    });
  };

  // Main fetch and render flow
  const fetchAndRender = async () => {
    tableBody.innerHTML = `<tr><td colspan="5" style="text-align:center;">Loading...</td></tr>`;

    const result = await fetchPointsData(customerPhone, currentPage - 1, pageSize);
    // const result = await fetchPointsData(customerPhone, currentPage - 1, 2);

    console.log("result ",result);

    if (!result.success || !result.data?.customerPointsHistory?.pointsHistoryList) {
      tableBody.innerHTML = `<tr><td colspan="5" style="text-align:center;color:red;">Error loading data</td></tr>`;
      return;
    }

    totalPages = result.data.page?.totalPages || 1;

    let transactions = result.data.customerPointsHistory.pointsHistoryList || [];

    // Sort client side
    transactions = sortTransactions(transactions, sortBy);

    renderTable(transactions);
    renderPagination();
  };


  /* =========== Non registered customer on yalla ============= */

  const openPopup = () => {
    // popup?.setAttribute('aria-hidden', 'false');
    popup?.removeAttribute('inert');
    popup?.classList.add('yalla-popup--visible');
    document.body.style.overflow = 'hidden';
  };

  const closePopup = () => {
    popup?.setAttribute('inert', '');
    // popup?.setAttribute('aria-hidden', 'true');
    popup?.classList.remove('yalla-popup--visible');
    document.body.style.overflow = '';
  };

  const handleConsentChange = () => {
    if (submitButton && consentCheckbox) {
      submitButton.disabled = !consentCheckbox.checked;
    }
  };

  const handleSubmit = async () => {
    const mainMessageContainer = document.querySelector('.registration__message');
    const popupMessageContainer = document.querySelector('.yalla-popup__message');
    if (!consentCheckbox?.checked) {
      showPreferenceMessage('Please accept the terms to continue.', 'error', popupMessageContainer);
      return;
    }
    const phoneInput = document.querySelector('#phone-number');
    const countryCode = document.querySelector('#selected-country');
    const otpHtml = document.querySelector('.yalla-popup__otp-wrapper');

    if(phoneInput && countryCode) {
      const phoneValue = phoneInput?.value?.trim();
      const countryPhoneCode = document.querySelector('#selected-country .country-phone-code')?.textContent || '';
      const fullNumber = `${countryPhoneCode}${phoneValue}`;
      if (!/^\d{8,15}$/.test(phoneValue)) {
        showPreferenceMessage('Please enter a valid phone number.', 'error', popupMessageContainer);
        phoneInput.focus();
        return;
      }

      window._countryPhoneCode = `${countryPhoneCode}`;
      window._phoneValue = `${phoneValue}`;
      generateOtp(countryPhoneCode, fullNumber, phoneValue);
    } else if(otpHtml) {
      // When OTP is generated
      const Otp = getOTP();
      const number = window._phoneValue?.trim() || '';
      const fullNumber = `${window._countryPhoneCode?.trim() || ''}${number}`;
      const popupMessageContainer = document.querySelector('.yalla-popup__message');

      if (Otp.length === 4) {
        try {
          // 1. Add phone to Shopify account
          const shopifyResponse = await addPhoneToShopifyAccount(storeHandle, customerId, fullNumber);

          if (shopifyResponse?.success) {
            try {
              // 2. Register in Yalla
              const yallaResult = await addCustomer(fullNumber, true, Otp);

              if (yallaResult.code === 200) {
                initiateRendering(fullNumber);
                showPreferenceMessage(yallaResult.message || 'Successfully verified!', 'success', popupMessageContainer);
                closePopup();
              } else {
                // 3. If Yalla fails, remove phone from Shopify
                try {
                  const resetPhoneResponse = await resetCustomerPhone(storeHandle, customerId );
                  showPreferenceMessage(yallaResult.message || resetPhoneResponse.message || 'Something went wrong. Please try again.', 'error', popupMessageContainer);
                } catch(error) {
                  // console.error(error);
                  showPreferenceMessage(yallaResult.message || 'Something went wrong. Please try again.', 'error', popupMessageContainer);
                }
              }
            } catch (yallaError) {
              // Yalla error — also rollback Shopify phone
              await resetCustomerPhone(storeHandle, customerId);
              showPreferenceMessage('Failed to register in Yalla.', 'error', popupMessageContainer);
              console.error('Yalla error:', yallaError);
            }
          } else {
            showPreferenceMessage(shopifyResponse.message || 'Failed to add phone to Shopify.', 'error', popupMessageContainer);
          }
        } catch (shopifyError) {
          showPreferenceMessage('Something went wrong while adding phone to Shopify.', 'error', popupMessageContainer);
          console.error('Shopify error:', shopifyError);
        }
      } else {
        showPreferenceMessage('Please enter the 4-digit OTP sent to your mobile number.', 'error', popupMessageContainer);
      }
    } else {
      // When customer already has phone number but not registered with yalla
      const checkboxStatus = consentCheckbox?.checked;
      const result = await addCustomer(customerPhone, checkboxStatus);

      if (result.code === 200) {
        registeredYallaSection?.classList.remove('hidden');
        initiateRendering();
        showPreferenceMessage(result.message || 'Successfully verified!', 'success', mainMessageContainer);
        closePopup();
      } else {
        showPreferenceMessage(result.error || result.message || 'Something went wrong. Please try again.', 'error', popupMessageContainer);
      }
    }
  };



  const addCustomer = async (customerPhone, checkboxStatus, otpReceived) => {
    if (!customerPhone) {
      console.error("Customer phone number is required.");
      return { code: 400, error: "Missing phone number" };
    }

    const customerData = {
      customer_data: {
        customer_details: [
          {
            number: customerPhone,
            ...(checkboxStatus && {
              consent: { pii_consent: 'opt_in' },
              loyalty_opt_in: 'yes'
            }),
            ...(otpReceived && {
              registration_otp: otpReceived
            }),
          },
        ],
      },
    };

    const options = {
      method: 'POST',
      headers: {
        accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(customerData),
    };

    try {
      const response = await fetch(`${GET_CUSTOMER_API}?action=add&shopName=reebok_ae`, options);

      if (!response.ok) {
        console.error(`API responded with status ${response.status}`);
        return { code: response.status, error: `HTTP ${response.status}` };
      }

      const data = await response.json();

      if (!data || typeof data !== 'object') {
        return { code: 422, error: 'Invalid response format' };
      }

      return data;
    } catch (error) {
      console.error('Error adding customer:', error);
      return { code: 400, error: error.message };
    }
  }

  /* ========== Yalla popup - add phone number to shopify account and yalla */
  const selectCountry = (e) => {
    const code = e.currentTarget.dataset.code;
    const selectedDiv = document.getElementById('selected-country');
    selectedDiv.dataset.code = code;
    selectedDiv.innerHTML = e.currentTarget.innerHTML;
    countryListBox.classList.add('hidden');
  }

  const openCountryList = () => {
    countryListBox.classList.toggle('hidden');
  }

  const handlePaste = function (paste, inputs) {
    const digits = paste.replace(/\D/g, '').slice(0, 4);
    inputs.forEach((input, i) => {
      input.value = digits[i] || '';
    });
    if (digits.length === 4) inputs[3].focus();
  }

  const openOtpPopup = function (fullNumber) {
    const registrationHtml = document.querySelector('.yalla-popup-registration__contents');
    const otpTemplate = document.querySelector('template.yalla-otp-popup');
    const otpContents = otpTemplate?.innerHTML;
    if(registrationHtml && otpTemplate) {
      registrationHtml.innerHTML = otpContents;
      registrationHtml.querySelector('.number').innerHTML = fullNumber;
      openPopup();
      const inputs = registrationHtml.querySelectorAll('.otp-input');
      const submitButton = registrationHtml.querySelector('.yalla-popup__submit-button');
      const resendOtpButton = registrationHtml.querySelector('.yalla-popup__resend-button');

      const checkOTPFields = function () {
        const allFilled = Array.from(inputs).every(input => input.value.length === 1);
        submitButton.disabled = !allFilled;
      }

      inputs.forEach((input, index) => {
        input.addEventListener('input', (e) => {
          const value = e.target.value;
          if (value.length > 1) {
            handlePaste(value, inputs);
            return;
          }
          if (value && index < inputs.length - 1) {
            inputs[index + 1].focus();
          }
          checkOTPFields();
        });

        input.addEventListener('keydown', (e) => {
          if (e.key === 'Backspace' && !input.value && index > 0) {
            inputs[index - 1].focus();
          }
          checkOTPFields();
        });

        input.addEventListener('paste', (e) => {
          const paste = e.clipboardData.getData('text');
          handlePaste(paste, inputs);
          e.preventDefault();
          checkOTPFields();
        });
      });
      submitButton?.addEventListener('click', handleSubmit);
      resendOtpButton?.addEventListener('click', function() {
        const countryPhoneCode = window._countryPhoneCode;
        const phoneValue = window._phoneValue;
        const fullNumber = `${countryPhoneCode}${phoneValue}`
        generateOtp(countryPhoneCode, fullNumber, phoneValue);
      })
    }
  }

  function getOTP() {
    const otp = Array.from(document.querySelectorAll('.otp-input'))
      .map(input => input.value)
      .join('');
    return otp;
  }

  function startOtpTimer(duration = 180) {
    const timerDisplay = document.getElementById('otp-timer');
    const resendButton = document.querySelector('.yalla-popup__resend-button');
    let remaining = duration;

    resendButton.disabled = true;

    const interval = setInterval(() => {
      const minutes = Math.floor(remaining / 60);
      const seconds = remaining % 60;

      // Format as MM:SS with leading zeros
      timerDisplay.textContent =
        `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;

      remaining--;

      if (remaining < 0) {
        clearInterval(interval);
        timerDisplay.textContent = '00:00';
        resendButton.disabled = false;
      }
    }, 1000);
  }

  // Generate registration OTP from yalla
  const generateOtp = async function(countryPhoneCode, phoneValue, phoneWithoutCode) {

    const fullNumber = `${countryPhoneCode} ${phoneWithoutCode}`;
    const popupMessageContainer = document.querySelector('.yalla-popup__message');

    try {
      const response = await fetch(`${GET_CUSTOMER_API}?action=generateCustomerOTP&shopName=reebok_ae`, {
        method: 'POST',
        headers: { accept: 'application/json', 'Content-Type': 'application/json' },
        body: JSON.stringify({ country_code: `${countryPhoneCode}`, phone: `${phoneValue}` })
      });

      const result = await response.json();
      // const result = {success: true, data: "some message"}; // for success testing purpose
      // const result = {success: false, data: "some message"}; // for failed testing purpose

      if (result.status) {
        closePopup(); // hide current popup
        openOtpPopup(fullNumber); // show OTP popup
        startOtpTimer(180);
      } else {
        showPreferenceMessage(result.message || 'Failed to send OTP.', 'error', popupMessageContainer);
      }
    } catch (error) {
      console.error('Error generating OTP: ', error);
      const result = {success: false, message: error.message}
      showPreferenceMessage(result.message || 'Failed to send OTP.', 'error', popupMessageContainer);
    }
  }

  const addPhoneToShopifyAccount = async (store_code, customer_id, customer_phone) => {
    if (!customer_phone) return;

    const customerData = {
      store_code,
      customer_id,
      customer_phone,
    };

    const options = {
      method: 'POST',
      headers: {
        accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(customerData),
    };

    try {
      const response = await fetch(`${ADD_PHONE_TO_SHOPIFY_ACCOUNT_API}`, options);
      const result = await response.json();

      // Check for userErrors from Shopify GraphQL response
      const userErrors = result?.data?.customerUpdate?.userErrors;
      if (userErrors && userErrors.length > 0) {
        return {
          success: false,
          message: userErrors[0].message || 'Unknown error',
          field: userErrors[0].field || null,
          allErrors: userErrors,
        };
      }

      // Success case
      return {
        success: true,
        customer: result.data.customerUpdate.customer,
      };
    } catch (error) {
      console.error("Error in addPhoneToShopifyAccount:", error);
      return {
        success: false,
        message: error.message || 'Something went wrong',
      };
    }
  };

  const resetCustomerPhone = async (store_code, customer_id) => {

    const customerData = {
      store_code,
      customer_id,
      customer_phone: ' ',
    };

    const options = {
      method: 'POST',
      headers: {
        accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(customerData),
    };

    try {
      const response = await fetch(`${ADD_PHONE_TO_SHOPIFY_ACCOUNT_API}`, options);
      const result = await response.json();

      // Check for userErrors from Shopify GraphQL response
      const userErrors = result?.data?.customerUpdate?.userErrors;
      if (userErrors && userErrors.length > 0) {
        return {
          success: false,
          message: userErrors[0].message || 'Unknown error',
          field: userErrors[0].field || null,
          allErrors: userErrors,
        };
      }

      // Success case
      return {
        success: true,
        customer: result.data.customerUpdate.customer,
      };
    } catch (error) {
      console.error("Error in addPhoneToShopifyAccount:", error);
      return {
        success: false,
        message: error.message || 'Something went wrong',
      };
    }
  }
}
